import { AxiosError } from "axios";
import { call, ForkEffect, put, takeLeading } from "redux-saga/effects";
import {
  getAllDevicesStatusesFailure,
  getAllDevicesStatusesSussess,
  getDevicesFailure,
  getDevicesSussess,
  getUserTagDevicesFailure,
  getUserTagDevicesSussess,
  getVitalsSettingsUserNearbyFailure,
  getVitalsSettingsUserNearbySussess,
  getVitalsUserNearbyFailure,
  getVitalsUserNearbySussess,
} from "../../redux/devices/actions";
import {
  DEVICES,
  IGetAllDevicesStatusesRequest,
  IGetDevicesRequest,
  IGetUserNearbyRequest,
} from "../../redux/devices/types";

import { residentsServiceStatusChange } from "../../redux/healthCheck/actions";
import { AxiosCustom } from "../../service/Axios";

export function* getDevicesWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(DEVICES.GET_DEVICES_REQUEST, getDevicesSaga);
}

function* getDevicesSaga(action: IGetDevicesRequest) {
  try {
    const response = yield call(() =>
      AxiosCustom.getDevices(action.payload.options)
    );
    yield put(getDevicesSussess(response.data.items));

    yield put(residentsServiceStatusChange(true));
    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;
    if (error?.response?.status === 503)
      yield put(residentsServiceStatusChange(false));
    yield put(getDevicesFailure(e.message));
  }
}

export function* getUserTagDevicesWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DEVICES.GET_USER_TAG_DEVICES_REQUEST,
    getUserTagDevicesSaga
  );
}

function* getUserTagDevicesSaga(action: IGetDevicesRequest) {
  try {
    const response = yield call(() =>
      AxiosCustom.getUserTagDevices(action.payload.options)
    );
    yield put(getUserTagDevicesSussess(response.data.items));
  } catch (error) {
    const e = error as AxiosError;
    if (error?.response?.status === 503)
      yield put(residentsServiceStatusChange(false));
    yield put(getUserTagDevicesFailure(e.message));
  }
}

export function* getDevicesStatusesWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DEVICES.GET_ALL_DEVICES_STATUSES_REQUEST,
    getDevicesStatusesSaga
  );
}

function* getDevicesStatusesSaga(action: IGetAllDevicesStatusesRequest) {
  try {
    const response = yield call(() => AxiosCustom.getDevices(action.payload));
    yield put(getAllDevicesStatusesSussess(response.data.items));
  } catch (error) {
    const e = error as AxiosError;
    if (error?.response?.status === 503)
      yield put(residentsServiceStatusChange(false));
    yield put(getAllDevicesStatusesFailure(e.message));
  }
}

export function* getVitalsUserNearbyWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(DEVICES.GET_USER_NEARBY_REQUEST, getVitalsUserNearbySaga);
}

function* getVitalsUserNearbySaga(action: IGetUserNearbyRequest) {
  try {
    const response = yield call(() => AxiosCustom.getVitalsUserNearby());
    yield put(getVitalsUserNearbySussess(response.data));

    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;

    yield put(getVitalsUserNearbyFailure(e.message));
  }
}

export function* getVitalsUserNearbySettingsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    DEVICES.GET_USER_NEARBY_SETTINGS_REQUEST,
    getVitalsUserNearbySettingsSaga
  );
}

function* getVitalsUserNearbySettingsSaga() {
  try {
    const response = yield call(() =>
      AxiosCustom.getUserNearbyDeviceSettings()
    );
    yield put(getVitalsSettingsUserNearbySussess(response.data));

    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;

    yield put(getVitalsSettingsUserNearbyFailure(e.message));
  }
}
